// src/features/rbac/hooks/useRoles.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchRoles, createRole, Role, RoleIn } from '../api/rbacApi';
import { deleteRole /* + existing imports */ } from '../api/rbacApi';


export function useRoles() {
  const qc = useQueryClient();
  const list = useQuery<Role[], Error>({
    queryKey : ['rbac','roles'],
    queryFn  : fetchRoles,
    staleTime: 60_000,
  });

  const add = useMutation<Role, Error, RoleIn>({
    mutationFn: createRole,
    onSuccess : () => qc.invalidateQueries({ queryKey: ['rbac','roles'] }),
  });

  const remove = useMutation<void, Error, string>({
    mutationFn : deleteRole,
    onSuccess  : () => qc.invalidateQueries({ queryKey: ['rbac','roles'] }),
  });

  return { ...list, add, remove };  
}